import React, { Fragment } from 'react';
import { BrowserRouter,Routes,Route } from 'react-router-dom';
import Footer from './components/Footer/Footer';
import Header from './components/Header/Header';
import FullScreenLoader from './components/MasterLayout/FullScreenLoader';
import CartPage from './pages/CartPage/CartPage';
import CheckOutPage from './pages/CheckOutPage/CheckOutPage';
import HomePage from './pages/HomePage/HomePage';
import LoginPage from './pages/LoginPage/LoginPage';
import NotFoundPage from './pages/NotFoundPage/NotFoundPage';
import ProductDetailsPage from './pages/ProductDetailsPage/ProductDetailsPage';
import RegistrationPage from './pages/RegistrationPage/RegistrationPage';
import ShopPage from './pages/ShopPage/ShopPage';
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import ShopCategoryPage from './pages/ShopCategoryPage/ShopCategoryPage';
import SearchPage from './pages/SearchPage/SearchPage';
import BillingPage from './pages/BillingPage/BillingPage';
import Success from './components/CheckOut/Success';
import MyOrderPage from './pages/MyOrderPage/MyOrderPage';
import ManageProfilePage from './pages/ManageProfilePage/ManageProfilePage';
import WishListPage from './pages/WishListPage/WishListPage';
import OrderDetailsPage from './pages/OrderDetailsPage/OrderDetailsPage';
import PrivateRoute from './utils/PrivateRoute';
import FalsePage from './pages/FalsePage/FalsePage';

const App = () => {
  return (
    <Fragment>
      <BrowserRouter>
      <ToastContainer/>
        <Header/>
          <Routes>
            <Route path="/" element={<HomePage/>}/>
            <Route path="/shop" element={<ShopPage/>}/>
            <Route path='/category/:category' element={<ShopCategoryPage/>} />
            <Route path='/search-all/:search' element={<SearchPage/>} />
            <Route path="/product-details/:id" element={<ProductDetailsPage/>}/>
            <Route path="/cart" element={<CartPage/>}/>
            <Route path="/billing-address" element={<PrivateRoute><BillingPage/></PrivateRoute>}/>
            <Route path="/checkout" element={<PrivateRoute><CheckOutPage/></PrivateRoute>}/>
            <Route path="/success" element={<Success/>}/>
            <Route path="/false" element={<FalsePage/>}/>
            <Route path="/my-order" element={<MyOrderPage/>}/>
            <Route path="/order-details/:id" element={<OrderDetailsPage/>}/>
            <Route path="/manage-profile" element={<ManageProfilePage/>}/>
            <Route path="/wishlist" element={<WishListPage/>}/>
            <Route path="/login" element={<LoginPage/>}/>
            <Route path="/registration" element={<RegistrationPage/>}/>
            <Route path="*" element={<NotFoundPage/>}/>
          </Routes>
        <Footer/>
      </BrowserRouter>
      <FullScreenLoader/>
    </Fragment>
  );
};

export default App;